
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { usePageAccess } from '@/hooks/usePageAccess';
import { useRole } from '@/contexts/RoleContext';

interface PageGuardProps {
  children: React.ReactNode;
  pageName: string;
}

const PageGuard = ({ children, pageName }: PageGuardProps) => {
  const { isPageLocked, loading } = usePageAccess();
  const { isAdmin, loading: roleLoading } = useRole();
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    if (loading || roleLoading) return;

    const locked = isPageLocked(pageName);
    if (locked && !isAdmin) {
      setShouldRedirect(true);
    } else {
      setShouldRedirect(false);
    }
  }, [isPageLocked, pageName, isAdmin, loading, roleLoading]);

  // Show loading state while checking access
  if (loading || roleLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Redirect to under construction if page is locked for non-admins
  if (shouldRedirect) {
    return <Navigate to="/under-construction" replace />;
  }

  // Render children if access is allowed
  return <>{children}</>;
};

export default PageGuard;
